import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { CommissionsDataInterface, CommissionsDownloadQueryInterface, CommissionsQueryInterface } from '@views/interfaces';

@Injectable({ providedIn: 'root' })
export class CommissionsService {
  constructor(private httpClient: HttpClient) { }

  async getCommissions(params: CommissionsQueryInterface): Promise<CommissionsDataInterface[]> {
    let queryParams = new HttpParams();
    for (const p in params) queryParams = queryParams.append(p, params[p]);
    const result = await firstValueFrom<
      ResponseCommonSI<CommissionsDataInterface[]>
    >(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.COMMISSIONS}`, {
        params: queryParams,
      })
    );
    return result.payload;
  }

  async download(params: CommissionsDownloadQueryInterface): Promise<{ base64: string }> {
    let queryParams = new HttpParams();
    for (const p in params) queryParams = queryParams.append(p, params[p]);
    const result = await firstValueFrom<
      ResponseCommonSI<{ base64: string }>
    >(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.COMMISSIONS}/download`, {
        params: queryParams,
      })
    );
    return result.payload;
  }
}
